import { createAction, props } from '@ngrx/store';
import { Job } from '../../models';

export const LoadJobs = createAction('[Content] Load Jobs');
export const LoadJobsSuccess = createAction('[Content] Load Jobs Success', props<{ offers: Job[] }>());
export const LoadJobsFail = createAction('[Content] Load Jobs Fail', props<{ error: any }>());
